const Navigation = () => {
    const navigation = document.querySelector('[data-navigation]')

    const closeAll = () => {
        navigation.querySelectorAll('li.sub-menu-active ul').forEach(animateEl)
    }

    const animateEl = (el, direction = 'close') => {
        const startHeight = 0
        const endHeight = `${el.scrollHeight}px`

        if (direction === 'open') {
            el.closest('li').classList.add('sub-menu-active')
        } else {
            el.closest('li').classList.remove('sub-menu-active')
        }

        // Start a WAAPI animation
        const animation = el.animate(
            {
                // Set the keyframes from the startHeight to endHeight
                height:
                    direction === 'open'
                        ? [startHeight, endHeight]
                        : [endHeight, startHeight],
            },
            {
                duration: 200,
                easing: 'ease-out',
            }
        )

        animation.onfinish = () => {
            if (direction === 'open') {
                el.style.height = endHeight
                for (let i = 0; i < el.children.length; i++) {
                    setTimeout(() => {
                        el.children[i].classList.add('navigation-item-fade-in')
                    }, i * 50)
                }
            } else {
                el.style.height = ''
                for (let i = 0; i < el.children.length; i++) {
                    el.children[i].classList.remove('navigation-item-fade-in')
                }
            }
        }
    }

    const toggleOpen = (button) => {
        if (button.closest('li').classList.contains('sub-menu-active')) {
            animateEl(button.closest('li').querySelector('ul'))
        } else {
            closeAll()
            animateEl(button.closest('li').querySelector('ul'), 'open')
        }
    }

    navigation?.addEventListener('click', (event) => {
        const target = event.target

        if (event.target.hasAttribute('data-sub-menu-button')) {
            event.stopPropagation()
            event.preventDefault()
            toggleOpen(target)
        }
    })
    window.addEventListener('off-canvas-close', closeAll)
    return true
}

export default Navigation
